import { render, staticRenderFns } from "./pic.vue?vue&type=template&id=5d2c8ab5&scoped=true"
import script from "./pic.vue?vue&type=script&lang=js"
export * from "./pic.vue?vue&type=script&lang=js"
import style0 from "./pic.vue?vue&type=style&index=0&id=5d2c8ab5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2c8ab5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d2c8ab5')) {
      api.createRecord('5d2c8ab5', component.options)
    } else {
      api.reload('5d2c8ab5', component.options)
    }
    module.hot.accept("./pic.vue?vue&type=template&id=5d2c8ab5&scoped=true", function () {
      api.rerender('5d2c8ab5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseTemplate/components/pic.vue"
export default component.exports